export default "__VITE_ASSET__ffbcdd0f__"